export const RouletteIcon = ({ className = "w-10 h-10" }: { className?: string }) => {
	return (
		<svg
			version="1.0"
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512.000000 512.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g
				transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
				fill="currentColor"
				stroke="none"
			>
				<path d="M2104 4823 l6 -298 225 -225 225 -225 230 230 230 230 0 292 0 293 -462 0 -461 0 7 -297z" />
				<path d="M1685 4481 c-142 -59 -281 -133 -395 -208 -112 -74 -260 -188 -260 -201 0 -4 280 -287 621 -628 l622 -622 51 23 c28 12 59 25 69 28 16 6 17 37 17 469 l0 463 -300 300 -300 300 0 57 c0 71 -1 71 -125 19z" />
				<path d="M3320 4467 l0 -52 -305 -305 -305 -305 0 -463 c0 -432 1 -463 18 -469 9 -3 40 -16 68 -28 l51 -23 624 624 c619 619 623 623 604 644 -29 32 -195 155 -283 209 -131 82 -423 221 -462 221 -6 0 -10 -24 -10 -53z" />
				<path d="M755 3794 c-278 -334 -478 -823 -512 -1247 l-6 -77 882 2 882 3 30 70 29 70 -624 624 -624 623 -57 -68z" />
				<path d="M3682 3237 l-622 -622 29 -70 30 -70 882 -3 882 -2 -7 80 c-27 328 -152 700 -331 990 -62 99 -189 273 -222 302 -18 17 -41 -5 -641 -605z" />
				<path d="M2493 2591 c-49 -13 -120 -58 -147 -94 -41 -53 -56 -101 -56 -175 0 -233 271 -358 448 -206 92 78 121 223 66 332 -43 86 -123 139 -221 147 -32 2 -72 0 -90 -4z" />
				<path d="M240 2134 c0 -56 29 -238 55 -349 78 -329 235 -649 448 -917 34 -42 64 -77 67 -78 3 0 285 280 628 623 l623 623 -25 54 c-14 30 -26 61 -26 68 0 9 -184 12 -885 12 l-885 0 0 -36z" />
				<path d="M3110 2158 c0 -7 -12 -38 -26 -68 l-25 -54 623 -623 c343 -343 625 -623 628 -623 10 1 130 157 194 253 148 223 277 527 331 787 21 101 45 262 45 305 l0 35 -885 0 c-701 0 -885 -3 -885 -12z" />
				<path d="M1647 1202 c-339 -339 -617 -622 -617 -627 1 -14 141 -123 256 -198 317 -208 674 -333 1057 -372 l67 -7 0 884 0 884 -69 27 c-38 15 -70 27 -72 27 -2 0 -282 -278 -622 -618z" />
				<path d="M2773 1792 l-63 -26 0 -884 0 -884 63 7 c395 41 758 169 1070 376 111 74 246 180 247 194 0 14 -1232 1245 -1245 1244 -6 -1 -38 -13 -72 -27z" />
			</g>
		</svg>
	);
};
